import React from 'react';
import { View } from 'react-native';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import { MODEL_TOTAL } from '@/constants/modelInventory.generated';
import { GhostCta, PrimaryCta, Section, useLanding } from './LandingKit';
import { fluid, isWeb } from './landingTokens';

const CAPABILITIES = [
  {
    icon: 'laptop',
    title: 'A computer to do the work.',
    copy: 'Your agent browses the web, writes and runs code, and works with files on its own computer. It can research, build, and create from start to finish.',
  },
  {
    icon: 'layer-group',
    title: `${MODEL_TOTAL} AI models at its disposal.`,
    copy: 'It can call any model in our library and combine them across a task. Reasoning, images, video, audio, and more, with the right model for each step.',
  },
  {
    icon: 'file-export',
    title: 'Finished work for you to review.',
    copy: 'Get websites, videos, presentations, spreadsheets, and documents you can use. Follow its progress, review the results, and ask for changes.',
  },
];

function LandingWorkMode() {
  const { c, band, isXS, isCompact, width } = useLanding();
  const size = fluid(width, 30, 40);

  return (
    <Section
      label="Work mode"
      background={band.bg}
      style={{ borderTopWidth: 1, borderTopColor: c.rule }}
      contentStyle={{ paddingTop: fluid(width, 48, 76), paddingBottom: fluid(width, 48, 76) }}
    >
      <View style={{ flexDirection: isCompact ? 'column' : 'row', gap: isCompact ? 36 : 64 }}>
        <View style={{ flex: isCompact ? undefined : 1, minWidth: 0 }}>
          <Text weight="medium" style={{ color: c.accent, fontSize: 15, marginBottom: 18 }}>Work mode</Text>
          <Text
            tag="h2"
            weight="semibold"
            style={{ color: c.ink, fontSize: size, lineHeight: Math.round(size * 1.12), letterSpacing: -size * 0.035, ...(isWeb ? { whiteSpace: 'pre-line' } : {}) }}
          >
            {'An AI agent with\nits own computer.'}
          </Text>
          <Text style={{ color: c.inkSoft, fontSize: 16, lineHeight: 26, marginTop: 22, maxWidth: 420 }}>
            Give Gab AI Work Agent a goal. It plans the steps, uses the models and tools it needs, and does the work. You set the direction and review what it delivers.
          </Text>
          <View style={{ flexDirection: isXS ? 'column' : 'row', flexWrap: 'wrap', alignItems: isXS ? 'stretch' : 'center', columnGap: 24, rowGap: 8, marginTop: 26 }}>
            <PrimaryCta restrained label="Get Work mode with Plus" full={isXS} />
            <GhostCta label="View plans" href="/pricing" />
          </View>
        </View>
        <View style={{ flex: isCompact ? undefined : 1.25, minWidth: 0 }}>
          {CAPABILITIES.map((item, index) => (
            <View key={item.title} style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 16, paddingTop: index === 0 ? 0 : 24, paddingBottom: 24, borderBottomWidth: 1, borderBottomColor: c.rule }}>
              <View style={{ width: 36, height: 36, borderRadius: 10, backgroundColor: c.accentWash, alignItems: 'center', justifyContent: 'center' }}>
                <Icon name={item.icon} size={16} color={c.accent} />
              </View>
              <View style={{ flex: 1, minWidth: 0 }}>
                <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 18, lineHeight: 25, letterSpacing: -0.25 }}>{item.title}</Text>
                <Text style={{ color: c.inkSoft, fontSize: 15, lineHeight: 24, marginTop: 9 }}>{item.copy}</Text>
              </View>
            </View>
          ))}
        </View>
      </View>
    </Section>
  );
}

export default React.memo(LandingWorkMode);
